export default __webpack_public_path__ + "static/media/hardbit_fekete.ff52da4e.svg";